import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HiringProcessProvider } from '../../context/HiringProcessContext';

function HiringProcess() {
  const { t } = useTranslation();
  return (
    <HiringProcessProvider>
      <div style={{ maxWidth: '780px', margin: '0 auto', padding: '24px 16px' }}>
        {/* The pages themselves will act as the Cards */}
        <Outlet />
        
        <div className="li-footer-links" style={{ marginTop: '24px' }}>
           <Link to="/about">{t('footer.about')}</Link>
           <Link to="/accessibility">{t('footer.accessibility')}</Link>
           <Link to="/help-center">{t('footer.helpCenter')}</Link>
           <Link to="/privacy-terms">{t('footer.privacyTerms')}</Link>
           <span style={{ display: 'block', marginTop: '8px' }}>{t('auth.footer.rights')}</span>
        </div>
      </div>
    </HiringProcessProvider>
  );
}

export default HiringProcess;
